import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from '@mui/material';
import { LibraryFolder, CreateFolderDto, UpdateFolderDto } from '../../types/library';

interface FolderDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: CreateFolderDto | UpdateFolderDto) => void;
  folder?: LibraryFolder | null;
  parentId?: number | null;
}

const FolderDialog: React.FC<FolderDialogProps> = ({
  open,
  onClose,
  onSubmit,
  folder,
  parentId,
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (folder) {
      setName(folder.name);
      setDescription(folder.description || '');
    } else {
      setName('');
      setDescription('');
    }
  }, [folder, open]);

  const handleSubmit = () => {
    if (!name.trim()) return;
    const data: any = {
      name: name.trim(),
      description: description.trim() || undefined,
    };
    if (!folder && parentId) {
      data.parent_id = parentId;
    }
    onSubmit(data);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{folder ? 'Edit Folder' : 'Create Folder'}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            autoFocus
            label="Folder Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            required
          />
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            multiline
            rows={2}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!name.trim()}>
          {folder ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FolderDialog;
